module.exports = __webpack_public_path__ + "static/media/Trivu_logo.891fb683.png";